import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { getPersonalicencia } from '../api/consulaLicenciaApi';
import { UseAuth } from "../hooks/useAuth";
import { withRouter } from "../hooks/withRouter";

// eslint-disable-next-line react-hooks/exhaustive-deps

function BusquedaLicencia(props) {
  const { location } = props.router;
 // const query = location.search
  const [result, setResult] = useState([])
  const { accessToken } = UseAuth();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


 useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getPersonalicencia(accessToken, location.search);
        setResult(response);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [accessToken, location.search]);

  if (error) {
    // Lanzar error dentro del render para que ErrorBoundary lo capture
    throw error;
  }




  const sortedResults = [...result].sort((a, b) => {
    const nameA = a.NOMBRE.toUpperCase();
    const nameB = b.NOMBRE.toUpperCase();
    if (nameA < nameB) {
        return -1;
    }
    if (nameA > nameB) {
        return 1;
    }
    return 0;
});
useEffect(() => {
  const timeout = setTimeout(() => {
    setLoading(false);
  }, 8000); // Tiempo de espera en milisegundos (en este caso 3 segundos)

  return () => clearTimeout(timeout);
}, []); // Se ejecuta solo en el montaje inicial

if (loading) {
  return (
    <div className='padron'>
      <div className='top-bar2'>
        <div className="top-bar">
          <div className="logo">
            {/* Botón con apariencia de logo que lleva a la página principal */}
            <Link to="/">
              <button className="logo-button">
                <img src="/img/logo.png" alt="Logo de la empresa" style={{ width: '50px', marginLeft: '20px' }} />
              </button>
            </Link>
          </div>
        </div>
      </div>
      <h1>Consulta Licencias</h1>

      <div className='padron'>Buscando...</div>
    </div>
  );
}

if (result.length === 0) {
  return (
    <div className='padron'>
      <div className='top-bar2'>
        <div className="top-bar">
          <div className="logo">
            {/* Botón con apariencia de logo que lleva a la página principal */}
            <Link to="/">
              <button className="logo-button">
                <img src="/img/logo.png" alt="Logo de la empresa" style={{ width: '50px', marginLeft: '20px' }} />
              </button>
            </Link>
          </div>
        </div>
      </div>
      <h1>Consulta Licencias</h1>

      <div className='padron'>No hay resultados</div>
    </div>
  );
}


return (
  <div>

    <div className='top-bar2'>
      <div className="top-bar">

        <div className="logo">
          {/* Botón con apariencia de logo que lleva a la página principal */}
          <Link to="/">
            <button className="logo-button">
              <img src="/img/logo.png" alt="Logo de la empresa" style={{ width: '50px', marginLeft: '20px' }} />
            </button>
          </Link>
        </div>
      </div>
    </div>
    <div className='padron'>

        <div className='results'>
          <h1>Consulta Licencia</h1>
          <div className='results-container'>
            <ul >
            {sortedResults.map((res, index) => (

<li className="res-list" key={index}>


                  <Link to={`/licencias-detalles/${res.ID}`} >
                    <h1>{res.NOMBRE}</h1>
                  </Link>

                </li>

              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default withRouter(BusquedaLicencia);
